

        jQuery(function() {
            var $module = jQuery('#m-1526562444003').children('.module');   
            var columns = $module.data('columns'),
                nav = $module.data('nav'), 
                dots = $module.data('dots'),
                center = $module.data('center'),
                autoplaytimeout = $module.data('autoplaytimeout'),
                autoplayhoverpause = $module.data('autoplayhoverpause');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'production') {
                var autoplay = $module.data('autoplay'), 
                    loop = $module.data('loop');
            } else {
                var autoplay = 0, 
                    loop = 0;
            }
        
            $module.owlCarousel({
                mouseDrag: false,
                nav: nav,
                dots: dots,
                autoplayHoverPause: autoplayhoverpause,
                autoplay: autoplay,
                autoplayTimeout: autoplaytimeout,
                center: center,
                loop: loop,
                navSpeed: 1200,
                autoWidth: !1,
                items: columns,
                responsive: {
                    0: {
                        items: 1,
                        nav: nav, 
                        dots: false 
                    },
                    700: {
                        items: columns,
                        nav: nav, 
                        dots: dots 
                    },
                    1000: {      
                        items: columns,
                        nav: nav, 
                        dots: dots,
                    },
                    1200: {      
                        items: columns,
                        nav: nav, 
                        dots: dots 
                    }
                }
            }); 
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563452073').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526562444011').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563159888').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526562444002').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526562835846').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526562444087').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526562598702').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526562443916').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526563480343').children('.module');   
            var columns = $module.data('columns'),
                nav = $module.data('nav'), 
                dots = $module.data('dots'),
                center = $module.data('center'),
                autoplaytimeout = $module.data('autoplaytimeout'),
                autoplayhoverpause = $module.data('autoplayhoverpause');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'production') {
                var autoplay = $module.data('autoplay'), 
                    loop = $module.data('loop');
            } else {
                var autoplay = 0, 
                    loop = 0;
            }
        
            $module.owlCarousel({
                mouseDrag: false,
                nav: nav,
                dots: dots,
                autoplayHoverPause: autoplayhoverpause,
                autoplay: autoplay,
                autoplayTimeout: autoplaytimeout,
                center: center,
                loop: loop,
                navSpeed: 1200,
                autoWidth: !1,
                items: columns,
                responsive: {
                    0: {
                        items: 1,
                        nav: nav, 
                        dots: false 
                    },
                    700: {
                        items: columns,
                        nav: nav, 
                        dots: dots 
                    },
                    1000: {      
                        items: columns,
                        nav: nav, 
                        dots: dots,
                    },
                    1200: {      
                        items: columns,
                        nav: nav, 
                        dots: dots 
                    }
                }
            }); 
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480361').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480304').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480274').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480331').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480412').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480277').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480270').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526563480323').children('.module');
        }); 
    